import styled from 'styled-components';
import { Box } from '@mui/material';

export var DataCardBody_Root = styled(Box).attrs(function () {return {
    p: 2
  };}).withConfig({ displayName: "DataCardBodystyle__DataCardBody_Root", componentId: "sc-qhj2hw-0" })([""]);
//# sourceMappingURL=DataCardBody.style.js.map